import type { LeadStageQuickChangeState } from './useLeadStageQuickChange';

const selectCls =
  'block w-full rounded-md border border-[rgba(55,53,47,0.16)] bg-transparent px-2.5 py-1.5 text-[13px] text-[#37352F] outline-none focus:border-[#2383E2] dark:border-white/15 dark:bg-[#202020] dark:text-white';
const labelCls = 'mb-1 block text-[11px] font-medium uppercase tracking-wide text-[#787774] dark:text-gray-500';

/** Select "Fase del lead" (+ motivo se la fase e' persa) nel modale di completamento task. */
export function LeadStageQuickChange({ state }: { state: LeadStageQuickChangeState }) {
  if (!state.available) return null;
  return (
    <div className="mt-4 space-y-3">
      <div>
        <label htmlFor="task-completion-lead-stage" className={labelCls}>
          Fase del lead
        </label>
        <select
          id="task-completion-lead-stage"
          className={selectCls}
          value={state.stageId}
          onChange={(e) => state.setStageId(e.target.value)}
        >
          {!state.stageId && <option value="">Seleziona fase...</option>}
          {state.stages.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>
      </div>
      {state.selectedIsLost && (
        <div>
          <label htmlFor="task-completion-lost-reason" className={labelCls}>
            Motivo della perdita<span className="ml-0.5 text-[#EB5757]">*</span>
          </label>
          <select
            id="task-completion-lost-reason"
            className={selectCls}
            value={state.lostReason}
            onChange={(e) => state.setLostReason(e.target.value)}
          >
            <option value="">Seleziona motivo...</option>
            {state.lostReasons.map((r) => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}
